import { render, staticRenderFns } from "./TaskUpdateBeforeWork.vue?vue&type=template&id=107504fd&scoped=true&"
import script from "./TaskUpdateBeforeWork.vue?vue&type=script&lang=js&"
export * from "./TaskUpdateBeforeWork.vue?vue&type=script&lang=js&"
import style0 from "./TaskUpdateBeforeWork.vue?vue&type=style&index=0&id=107504fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107504fd",
  null
  
)

export default component.exports